import React from 'react';
import {
  Checkbox,
} from 'material-ui';
import {
  translate as t,
} from 'admin-on-rest';

class PositionPicker extends React.Component {
  onCheck = (position) => () => {
    const prevChecked = this.props.checked || [];
    const pos = prevChecked.indexOf(position);
    let checked = [];
    if (pos > -1) {
      // Remove
      checked = [
        ...prevChecked.slice(0, pos),
        ...prevChecked.slice(pos + 1),
      ];
    } else {
      // Add
      checked = [
        ...prevChecked,
        position,
      ];
    }
    this.props.onChange(checked);
  }

  onCheckAll = (_, isChecked) => {
    if (isChecked) {
      this.props.onChange(this.props.positions);
    } else {
      this.props.onChange([]);
    }
  }


  getCheckbox = (position) => (
    <Checkbox
      key={position}
      label={this.props.translate(position)}
      checked={this.props.checked.indexOf(position) > -1}
      onCheck={this.onCheck(position)}
    />
  )

  render() {
    const { positions = [], checked, translate } = this.props;
    const allSelected = positions.every((position) => checked.indexOf(position) > -1);
    return (
      <div>
        <Checkbox
          label={translate('documents.directory.chooseAll')}
          checked={allSelected}
          onCheck={this.onCheckAll}
        />
        {positions.map(this.getCheckbox)}
      </div>
    );
  }
}

export default t(PositionPicker);
